// extracted by css-extract-rspack-plugin
export default {"selector":"lL2zA25XJ_0fXnRz","fullWidthAnalysisUnits":"dI0BOIYDnk8coyNK","analysisUnitsError":"ZvL162iJa6kvPKsZ"};